import { NextRouter } from "next/router";

import { atom } from "jotai";

const nextRouterAtom = atom<NextRouter | undefined>(undefined);
nextRouterAtom.debugLabel = "nextRouter";

export { nextRouterAtom };
